import React, { useState, useEffect, useRef, useContext } from "react";
import { useSelector } from "react-redux";
import Loader from "../../../components/loading/Loader";
import CustomRadioGroup from "../components/CustomRadioGroup";
import FeaturesContainer from "../components/FeaturesContainer";
import {
  setCurrentAppType,
  setCurrentRole,
} from "../../../stateManagement/actions/roleActions";
import {
  AppOptionType,
  OptionType,
} from "../../manageHomepage/ManageHomePageTypes";
import {
  featureSelectionScreenInit,
  getFinalMetaDataPayloadFeatureSelection,
  getStudioConfigMap,
  updateConfigFeatureSelection,
} from "../../../services/uiConfigService";
import { usePopup } from "../../../components/newPortal/PopUpContext";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { StudioRoleSelectionAndSavePopupModal } from "../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal";
import RequiredConfigModal from "../../salescodeStudio/feautreSelection/components/requiredConfigModal";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import { FeatureSelectionOptionsContext } from "../components/FeatureSelectionOptionsContext";

export interface FeatureSelectionScreenPropsTypes {
  uiConfigOptionsProp: otherConfigOptionsAttributes[];
  setUiConfigOptionsProp: React.Dispatch<React.SetStateAction<otherConfigOptionsAttributes[]>>;
}

const FeatureManagementSettings = ({
  uiConfigOptionsProp,
  setUiConfigOptionsProp,
}: FeatureSelectionScreenPropsTypes) => {
  const [loading, setLoading] = useState(true);
  const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
  const [appTypeOptions, setAppTypeOptions] = useState<AppOptionType[]>([]);
  const [allConfigOptions, setAllConfigOptions] = useState<otherConfigOptionsAttributes[]>([]);
  const clientConfigRef = useRef<any[]>([]);
   const currentConfigRef = useRef<any>({});
   
  const savedAppType = useSelector((state: any) => state.appTypeState.appType);
  const savedRole = useSelector((state: any) => state.roleState.role) ?? savedAppType?.designations?.[0];
  const [standard, setStandard] = useState<string | undefined>(undefined);
  const { showPopup } = usePopup();
  const {featureChangeList=[],setFeatureChangeList=()=>{},setOnSaved=()=>{}}=useContext(FeatureSelectionOptionsContext)

  const handleSubmit = async () => {
    if (!savedRole || !savedAppType) return;
 currentConfigRef.current=await getStudioConfigMap({"clientconfig":["app_feature_configuration","app_layout_configuration","app_options_configuration"]})
    const finalMetaDataPayload =await getFinalMetaDataPayloadFeatureSelection(
      savedRole,
      savedAppType,
      uiConfigOptionsProp,
      clientConfigRef,
      featureChangeList,
      currentConfigRef
    );
    if (!finalMetaDataPayload) {
      return;
    }
    const initialConfigMap: Record<string, any> = {"clientconfig": currentConfigRef.current["clientconfig"]};
    const updatedConfig:any[] = structuredClone(currentConfigRef.current["clientconfig"]);
    updatedConfig.forEach((config) => {
      const domainType = config.domainType;
      const feature = finalMetaDataPayload.features.find((feature) => feature.domainType === domainType);
      if(feature){
        config.domainValues = feature.domainValues;
      }
    });
    const updatedConfigMap : Record<string,any> = {"clientconfig": updatedConfig};
    const requiredConfigsMap = {
      "clientconfig" : finalMetaDataPayload?.features?.map((obj: Record<string, any>) => obj.domainType) ?? [],
    }
    const filterdinitialconfig=initialConfigMap["clientconfig"].filter((config:any)=>finalMetaDataPayload.features.find((data:any)=>data.domainType===config.domainType))
    const updatedinitialconfig=updatedConfigMap["clientconfig"].filter((config:any)=>finalMetaDataPayload.features.find((data:any)=>data.domainType===config.domainType))
    initialConfigMap["clientconfig"]=filterdinitialconfig;
    updatedinitialconfig["clientconfig"]=updatedinitialconfig
    showPopup((close) => (
      <StudioRoleSelectionAndSavePopupModal
        inputData={{
          requiredConfigsMap: requiredConfigsMap,
          initialConfigMap: initialConfigMap,
          updatedConfigMap,
          appType: savedAppType,
          role: savedRole,
          affectAppTypeSpecificConfig: false,
          featureSelectionFlag : true
        }}
        actionPostSuccess={()=>{
          init()
        setOnSaved((prev)=>!prev)
        }}
        onCancel={close}
      />
    ));
  };

  const init = async () => {
    try {
      await featureSelectionScreenInit(setLoading,clientConfigRef,setStandard,setAppTypeOptions,setRoleOptions,uiConfigOptionsProp,setUiConfigOptionsProp,setAllConfigOptions,savedRole,savedAppType);
    } catch (error) {
      console.log("Error in init: ", error);
      openPopup("Error", "An error occurred while initializing the configuration. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  // useEffect(()=>{
  //     if(uiConfigOptionsProp.length !== 0  && isFirstTime && savedRole){
  //       setIsFirstTime(false);
  //       updateConfigFeatureSelection(savedRole,savedAppType,uiConfigOptionsProp,clientConfigRef,setUiConfigOptionsProp,setAllConfigOptions);
  //     }
  //   },[uiConfigOptionsProp])
    
  useEffect(() => {
    updateConfigFeatureSelection(savedRole,savedAppType,uiConfigOptionsProp,clientConfigRef,setUiConfigOptionsProp,setAllConfigOptions);
  },[savedRole,savedAppType,standard,uiConfigOptionsProp]);



  return loading || uiConfigOptionsProp.length === 0 ? (
    <Loader />
  ) : (
    <div style={{ 
      // minHeight: "100vh",
      height: "100%",
      backgroundColor: "#ffffff",
      padding: "0"
    }}>
      {/* Header Section */}
      <div style={{
        backgroundColor: "#ffffff",
        padding: "10px 22px 0px 22px",
      }}>
        <h6 style={{ 
          fontSize: "25px", 
          fontWeight: 600,
          color: "#333333",
          margin: "0 0 4px 0"
        }}>
          Feature management
        </h6>
        <p style={{ 
          fontSize: "16px", 
          color: "#666666",
          margin: "0",
          fontWeight: 400
        }}>
          Choose the features you want to enable or disable in the studio for a specific application and role.
        </p>
      </div>

      {/* Main Content Container */}
      <div style={{ 
        padding: "16px 24px 0px 24px",
        maxWidth: "1120px",
        margin: "0 auto",
        height: "80%"
      }}>
        {/* Selection Container */}
        <div style={{
          backgroundColor: "#ffffff",
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          padding: "14px",
          marginBottom: "0px",
          height: "100%",
          overflow: "scroll"
        }}>
          {/* Application Selection */}
          <div style={{
            marginBottom: "24px"
          }}>
            <h3 style={{ 
              fontSize: "16px", 
              fontWeight: 400, 
              marginBottom: "14px",
              color: "#333333"
            }}>
              Select the application
            </h3>
            <CustomRadioGroup
              name="application"
              options={appTypeOptions}
              selected={savedAppType}
              getLabel={(appType) => appType.label}
              getValue={(appType) => appType.id}
              onChange={(selectedAppType) => {
                setCurrentAppType(selectedAppType);
                const defaultRole = selectedAppType.designations?.[0];
                // only change role if it is not the same as the saved role
                if(defaultRole?.id !== savedRole?.id){
                  setCurrentRole(defaultRole);
                }
                setRoleOptions(selectedAppType.designations || []);
              }}
            />
          </div>

          <div style={{
            marginBottom: "24px"
          }}>
            <h3 style={{ 
              fontSize: "16px", 
              fontWeight: 400, 
              marginBottom: "14px",
              color: "#333333"
            }}>
              Select the designation
            </h3>
            <CustomRadioGroup
              name="designation"
              options={roleOptions}
              selected={savedRole}
              getLabel={(role) => role.label}
              getValue={(role) => role.id}
              onChange={(selectedRole) => {
                // only change role if it is not the same as the saved role
                if(selectedRole?.id !== savedRole?.id){
                  setCurrentRole(selectedRole);
                }
                
              }}
            />
          </div>

          <div style={{ 
            height: "500px",
            position: "relative"
          }}>
            <FeaturesContainer
              currentRole={savedRole}
              allConfigOptions={allConfigOptions}
              setAllConfigOptions={setAllConfigOptions}
              setFeatureChangeList={setFeatureChangeList}
              standard={standard}
            />
          </div>
        </div>

      {/* we need some configs to be filled before moving to this step , so we first check if those are present , else those are filled via this modal */}
      <RequiredConfigModal savedRole={savedRole} savedAppType={savedAppType} roleOptionsProps={roleOptions} appTypeOptions={appTypeOptions} parentCallback={()=>{
        init();
      }} />
    </div>
    {/* Sticky Action Buttons */}
    <div style={{
      height: "9%",
      position: "relative",
      bottom : 0,
      backgroundColor: "#ffffff",
      borderTop: "1px solid #e0e0e0",
      borderRadius: 6,
      padding: "12px 20px",
      display: "flex",
      justifyContent: "flex-end",
      gap: "16px",
      zIndex: 100,
      boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
      width: "100%",
      margin: "10px auto",
      marginBottom: 0
    }}>
      <button
        style={{
          backgroundColor: "#ffffff",
          color: "#666666",
          border: "1px solid #d1d5db",
          padding: "12px 24px",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 400,
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#f9fafb";
          e.currentTarget.style.borderColor = "#9ca3af";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#ffffff";
          e.currentTarget.style.borderColor = "#d1d5db";
        }}
      >
        Cancel
      </button>
      <button
        onClick={handleSubmit}
        style={{
          backgroundColor: "#10b981",
          color: "#ffffff",
          border: "none",
          padding: "12px 24px",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 400,
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#059669";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#10b981";
        }}
      >
        Save Changes
      </button>
    </div>
    </div>
  );
};

export default FeatureManagementSettings;